import { getTabTool } from '@fno/service/api/tasks.js'
import stepIdToRoute from '../step-id-to-route.js'
import template from './Task.svelte'

import contactInfo from './contact-info/contact-info.js'
import appNaming from './app-naming/app-naming.js'
import affiliations from './affiliations/affiliations.js'
import developerAccount from './developer-account/developer-account.js'
import appIcons from './app-icons/app-icons.js'
import appColors from './app-colors/app-colors.js'
import teams from './teams/teams.js'
import venues from './venues/venues.js'
import features from './features/features.js'
import allDone from './all-done/all-done.js'

// Routing scenarios:
// 1. If there's no task, we kick you back to the setup page
// that tell you to contact a CSC
// 2. If you land at `app.task` with no child specified, we check
// to see what the last step is that you were working on, and
// send you there.
// 3. If you've finished all of tasks but not completed the
// onboarding, we'll send you to the allDone page.
// 4. If you have a task, but no progress, you'll be routed to
// the welcome page.
const resolve = async (ignore, { schoolId }) => {
    const task = await getTabTool({ schoolId })
    if (!task || window.location.hash.endsWith('/task')) {
        const firstIncompleteStep = task && task.attributes.steps.find(step => step.status !== 'COMPLETED')
        let routeName

        if (!task) {
            routeName = 'hello.setup'
        } else {
            const mapByStatus = task && task.attributes.steps.reduce((map, step) => {
                const key = step.status
                map[key] = map[key] ? map[key] + 1 : 1
                return map
            }, { COMPLETED: 0, REQUESTED: 0 })

            const allTasksCompleted = mapByStatus.COMPLETED === task.attributes.steps.length
            const hasNotStarted = mapByStatus.REQUESTED === task.attributes.steps.length

            if (hasNotStarted) {
                routeName = 'hello.welcome'
            } else if (allTasksCompleted) {
                routeName = 'hello.task.allDone'
            } else {
                routeName = stepIdToRoute[firstIncompleteStep && firstIncompleteStep.id] || 'hello.task.contactInfo'
            }
        }

        return Promise.reject({
            redirectTo: {
                name: routeName,
                params: { schoolId }
            }
        })
    }

    return { task }
}

export default (parent, stateRouter) => {
    const name = `${parent}.task`

    stateRouter.addState({
        name,
        route: '/task',
        template,
        resolve,
        data: {
            title: 'T.A.B.'
        }
    })

    contactInfo(name, stateRouter)
    appNaming(name, stateRouter)
    affiliations(name, stateRouter)
    developerAccount(name, stateRouter)
    appIcons(name, stateRouter)
    appColors(name, stateRouter)
    teams(name, stateRouter)
    venues(name, stateRouter)
    features(name, stateRouter)
    allDone(name, stateRouter)
}
